'use client';

import { motion } from 'framer-motion';
import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { PageManifestoSchema } from '@/sanity/pages/PageManifestoTemplate';
import { GroqImage } from '@/helpers/Image';

const ease = [0.25, 0.1, 0.25, 1] as const;

function IQLogoIcon() {
  return (
    <svg
      className="w-[3.875rem] h-[3.875rem] shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      fill="none"
      viewBox="0 0 31 31"
    >
      <rect width="31" height="31" fill="#fff" rx="2"></rect>
      <path
        fill="#000"
        d="M24.662 20.18c-2.593 0-4.702-2.1-4.702-4.68h-4.216c0 4.893 4 8.875 8.918 8.875z"
      ></path>
      <path
        fill="#000"
        d="M15.255 6.625c-4.917 0-8.917 3.98-8.917 8.874s4 8.875 8.917 8.875v-4.195c-2.592 0-4.702-2.1-4.702-4.68s2.11-4.679 4.702-4.679 4.702 2.1 4.702 4.68h4.216c0-4.894-4-8.875-8.918-8.875"
      ></path>
    </svg>
  );
}

export default function MissionBannerSection({
  data,
}: {
  data: PageManifestoSchema;
}) {
  if (!data?.missionText) return null;

  return (
    <div className="relative w-full flex flex-col items-center py-[4rem] bg-white">
      <div className="lg:w-[min(94.5rem,calc(100%-8rem))] w-[min(94.5rem,calc(100%-4rem))] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease }}
          className="relative bg-black rounded-[0.25rem] px-[3rem] py-[4rem] flex flex-col items-start gap-[3rem] overflow-hidden lg:flex-row lg:px-[11.5rem] lg:py-[6.375rem] lg:gap-[6.875rem]"
        >
          {data.missionBannerImage && (
            <GroqImage
              src={data.missionBannerImage}
              alt=""
              className="!absolute !inset-0 !w-full !h-full !object-cover mix-blend-luminosity opacity-40 pointer-events-none"
            />
          )}
          <IQLogoIcon />
          <div className="richtext richtext-start prose-p:text-white prose-p:text-[2.5rem] prose-p:lg:text-[3rem] prose-p:lg:tracking-[-0.15rem] prose-p:leading-[1.3] prose-strong:text-white prose-strong:font-semibold prose-p:tracking-[-0.125rem]">
            <PortableText
              value={data.missionText}
              components={richTextComponent}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
